/* eslint-disable react-hooks/exhaustive-deps */
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { errorToast, successToast } from "../../components/Toast";
import { getBuyerByIdApi, updateBuyerApi } from "../../services/_buyer";
import CountryStateCityField from "../other/CountryStateCityField";
import {
  getCities,
  getCountries,
  getStateCityList,
  getStates,
} from "../../components/Helper";

const EditBuyer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);
  const countryList = getCountries();
  const [stateList, setStateList] = useState<any>([]);
  const [cityList, setCityList] = useState<any>([]);

  const handleCountryChange = (country: any) => {
    setStateList([]);
    setCityList([]);
    const allStates = getStates(country);
    setStateList(allStates);
  };
  const handleStateChange = (state: any) => {
    setCityList([]);
    const cities = getCities(state);
    setCityList(cities);
  };
  const setStateCityList = async (countryName: any, stateName: any) => {
    const { allStates, allCities } = await getStateCityList(
      countryName,
      stateName
    );
    setStateList(allStates);
    setCityList(allCities);
  };

  useEffect(() => {
    if (!id) {
      navigate("/buyer-list");
    } else {
      getBuyerDetails();
    }
  }, []);

  const getBuyerDetails = async () => {
    const result: any = await getBuyerByIdApi(id as string);
    setStateCityList(result?.data?.country, result?.data?.state);

    if (result.isSuccess) {
      setInitialValues({
        name: result?.data?.name,
        email: result?.data?.email,
        phone_no: result?.data?.phone_no,
        tan_no: result?.data?.tan_no,
        gst_no: result?.data?.gst_no,
        pan_no: result?.data?.pan_no,
        udhyam_no: result?.data?.udhyam_no,
        buyer_name: result?.data?.buyer_name,
        tax_id: result?.data?.tax_id,
        address: result?.data?.address,
        country: result?.data?.country,
        state: result?.data?.state,
        city: result?.data?.city,
        pin_code: result?.data?.pin_code,
        status: result?.data?.status?.toString(),
      });
    }
  };

  const createBuyerInitialValues = {
    name: "",
    email: "",
    phone_no: "",
    tan_no: "",
    gst_no: "",
    pan_no: "",
    udhyam_no: "",
    buyer_name: "",
    tax_id: "",
    address: "",
    country: "",
    state: "",
    city: "",
    pin_code: "",
    status: "",
  };
  const [initialValues, setInitialValues] = useState(createBuyerInitialValues);

  const createBuyerValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    status: Yup.string().required("Status is required"),
  });

  const handleSubmit = async (values: any, { resetForm }: any) => {
    setUpdateLoading(true);
    const updatedValues = {
      ...values,
      status: values.status === "true",
    };
    const result: any = await updateBuyerApi(id as string, updatedValues);
    if (result.isSuccess) {
      setUpdateLoading(false);
      resetForm({ values: createBuyerInitialValues });
      successToast(result.message);
      navigate("/buyer-list");
    } else {
      setUpdateLoading(false);
      errorToast(result.message);
    }
    return;
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0">
          <div>
            <h5>Edit Buyer</h5>
          </div>
        </div>
        <div className="card-body">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={createBuyerValidationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleChange, values, setFieldValue }) => {
              return (
                <Form className="dt_adv_search">
                  <div className="row">
                    <div className="col-12">
                      <div className="row g-3">
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="name"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Name: <span className="text-danger">*</span>
                          </label>
                          <Field
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Enter name"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name="name"
                            className="text-danger"
                            component="div"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="email"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Email:
                          </label>
                          <Field
                            id="email"
                            name="email"
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name="email"
                            className="text-danger"
                            component="div"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="phone_no"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Phone No:
                          </label>
                          <Field
                            id="phone_no"
                            name="phone_no"
                            type="text"
                            className="form-control"
                            placeholder="Enter phone no"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="pan_no"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            PAN No:
                          </label>
                          <Field
                            id="pan_no"
                            name="pan_no"
                            type="text"
                            className="form-control"
                            placeholder="Enter PAN No"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="gst_no"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            GST No:
                          </label>
                          <Field
                            id="gst_no"
                            name="gst_no"
                            type="text"
                            className="form-control"
                            placeholder="Enter GST No"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="tan_no"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            TAN No:
                          </label>
                          <Field
                            id="tan_no"
                            name="tan_no"
                            type="text"
                            className="form-control"
                            placeholder="Enter TAN No"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="udhyam_no"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            UDHYAM No:
                          </label>
                          <Field
                            id="udhyam_no"
                            name="udhyam_no"
                            type="text"
                            className="form-control"
                            placeholder="Enter UDHYAM No"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="buyer_name"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Buyer Name:
                          </label>
                          <Field
                            id="buyer_name"
                            name="buyer_name"
                            type="text"
                            className="form-control"
                            placeholder="Enter Buyer Name"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name="buyer_name"
                            className="text-danger"
                            component="div"
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="tax_id"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Tax Id:
                          </label>
                          <Field
                            id="tax_id"
                            name="tax_id"
                            type="text"
                            className="form-control"
                            placeholder="Enter Tax Id"
                            onChange={handleChange}
                          />
                          <ErrorMessage
                            name="tax_id"
                            className="text-danger"
                            component="div"
                          />
                        </div>
                        <CountryStateCityField
                          countryList={countryList}
                          stateList={stateList}
                          cityList={cityList}
                          values={values}
                          setFieldValue={setFieldValue}
                          handleCountryChange={handleCountryChange}
                          handleStateChange={handleStateChange}
                        />
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="pin_code"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Pin Code:
                          </label>
                          <Field
                            id="pin_code"
                            name="pin_code"
                            type="text"
                            className="form-control"
                            placeholder="Enter Pin Code"
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="status"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Status: <span className="text-danger">*</span>
                          </label>
                          <select
                            id="status"
                            name="status"
                            className="form-select"
                            onChange={handleChange}
                            value={values?.status}
                          >
                            <option value="">Select Status</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                          <ErrorMessage
                            name="status"
                            className="text-danger"
                            component="div"
                          />
                        </div>
                        <div className="col-12">
                          <label
                            htmlFor="address"
                            className="form-label"
                            style={{ fontSize: "0.9375rem" }}
                          >
                            Address:
                          </label>
                          <Field
                            id="address"
                            name="address"
                            type="text"
                            className="form-control"
                            placeholder="Enter Address"
                            onChange={handleChange}
                            as={"textarea"}
                            rows={2}
                          />
                        </div>
                        <div className="col-12">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={updateLoading}
                          >
                            {updateLoading && (
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            )}
                            Submit
                          </button>
                          <Link
                            to={"/buyer-list"}
                            type="button"
                            className="btn btn-label-github ms-5"
                          >
                            Back
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default EditBuyer;
